import type { ComponentType } from 'react';

import type { WizardChildProps } from '../../../components/Wizard/types';
import { Wizard } from '../../../components/Wizard/Wizard';
import { ChooseCountryWizardStepRedesign } from '../redesign-components/ChooseCountryRedesign/ChooseCountryWizardStepRedesign';
import { EmailVerificationRedesign } from '../redesign-components/EmailVerificationRedesign/EmailVerificationRedesign';
import { LogInOptionsRedesign } from '../redesign-components/LogInOptionsRedesign/LogInOptionsRedesign';
import { WelcomeBonusRedesign } from '../redesign-components/WelcomeBonusRedesign/WelcomeBonusRedesign';

import { authWizardWrapperStyle, LogInWizardStepsRedesign } from './constants';
import styles from './RedesignWizard.module.scss';

// Keyed by step so the order (numeric keys iterate ascending) can't drift from LogInWizardStepsRedesign,
// which callers use to open a given step.
const STEPS_REDESIGN = Object.values({
  [LogInWizardStepsRedesign.LogInOptions]: LogInOptionsRedesign,
  [LogInWizardStepsRedesign.EmailVerification]: EmailVerificationRedesign,
  [LogInWizardStepsRedesign.ChooseCountry]: ChooseCountryWizardStepRedesign,
  [LogInWizardStepsRedesign.WelcomeBonus]: WelcomeBonusRedesign,
} satisfies Record<LogInWizardStepsRedesign, ComponentType<WizardChildProps>>);

export default function LogInWizard() {
  return (
    <Wizard
      classNameSteps={styles.redesignFlowSteps}
      classNameStepWrapper={styles.redesignFlowStepWrapper}
      steps={STEPS_REDESIGN}
      wrapperStyle={authWizardWrapperStyle}
    />
  );
}
